module.exports = __webpack_public_path__ + "static/competicao-2-c8cfeee2c9155b587e509b7d56925ccb.jpeg";